import React, { FC, ReactChild } from "react"
import { container } from "./styles"

interface HighlightProps {
  children?: ReactChild
  onClick?: () => void
  link?: string
  target?: string
}

/**
 * Highlight the text
 *
 * @param {*} { children }
 */
const Highlight: FC<HighlightProps> = ({
  children,
  onClick,
  link,
  target = "_blank",
}) => (
  <a
    role="button"
    href={link}
    target={target}
    onClick={onClick}
    css={container}
  >
    {children}
  </a>
)

export default Highlight
